import axios from '@/plugins/axios'
import * as typesAPI from '@/models/api/models-api'
import { backendAPIConfig } from '@baseConfig'
import { StringHelper } from '@/helpers/string'
import { HttpStatus } from '@/models/converter/convert'
import { GetLineOauthRequest } from '@/models/api/line-oauth'

export class LineOauthApi {
    /**
     * Web-LINE会員証取得
     * @public
     * @async
     * @param {GetLineOauthRequest} request
     * @returns {typesAPI.APIResponse}
     */
    async getLineOauth(request) {
        let res = {}
        if (request.mock) {
            res = {
                "data": {
                    "is_authenticated": true,
                    "brandsite": "albion",
                    "lineid": "TPTaaaaaaaaaaaaaaaaaaaaaaaaaa001"
                },
                "status": 200,
            }
        } else {
            res = await axios.get(`${backendAPIConfig.endpoint}/web/line/oauth`, {
                params: {
                    provision_shop_code: request.provisionShopCode,
                }
            })
        }
        return res
    }
}
